/**
 * useWorkspaceDefault — what "Workspace default" means right now for an agent
 * (phase M, M4-2): the workspace chat ranking's first choice, from
 * GET /api/agents/{id}/model-resolution → data.workspace_default, or, for an
 * agent not saved yet, GET /api/llm/workspace-default. Returns null while
 * loading, when nothing is configured, or when the lookup fails (the label then
 * reads just "Workspace default").
 */
import { useEffect, useState } from "react";
import { agentApi, llmApi } from "../api/client";

export function useWorkspaceDefault(agentId) {
  const [workspaceDefault, setWorkspaceDefault] = useState(null);

  useEffect(() => {
    let alive = true;
    setWorkspaceDefault(null);
    const lookup = agentId
      ? agentApi.modelResolution(agentId).then((res) => res?.data?.workspace_default)
      : llmApi.workspaceDefault().then((res) => res?.data);
    lookup
      .then((wd) => { if (alive) setWorkspaceDefault(wd || null); })
      .catch(() => { if (alive) setWorkspaceDefault(null); });
    return () => { alive = false; };
  }, [agentId]);

  return workspaceDefault;
}
